<div class="m-subheader">
  <div class="d-flex align-items-center">
    <div class="mr-auto">
      <h3 class="m-subheader__title">
        {{ 'spend-list.title' | transloco }}
      </h3>
    </div>
    <div>
      <a class="btn btn-success m-btn m-btn--custom m-btn--icon" routerLink="new">
        <span>
          <i class="la la-plus"></i>
          <span>
            {{ 'spend-list.addExpense' | transloco }}
          </span>
        </span>
      </a>
    </div>
  </div>
</div>
<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="row m--margin-bottom-10">
              <div class="filter">
                <small>{{ 'spend-list.shop' | transloco }}</small>
                <hx-store-select [(ngModel)]="params.storeIds" [multiple]="true" (selectChange)="applyFilters()"></hx-store-select>
              </div>

              <div class="filter">
                <small>{{ 'spend-list.incomingDate' | transloco }}</small>
                <hx-date-range-select [(ngModel)]="params.date" (selectChange)="applyFilters()"></hx-date-range-select>
              </div>

              <div class="filter">
                <small>{{ 'spend-list.payBefore' | transloco }}</small>
                <hx-date-range-select [(ngModel)]="params.payBefore" (selectChange)="applyFilters()"></hx-date-range-select>
              </div>

              <div class="filter">
                <small>{{ 'spend-list.spendCategory' | transloco }}</small>
                <app-spend-category-search [code]="params.spendCategoryCode" (update)="spendCategoryChanged($event)"></app-spend-category-search>
              </div>

              <div class="filter">
                <small>{{ 'spend-list.cashflowName' | transloco }}</small>
                <app-spend-category-search [key]="DictionaryKey.cashFlows" [code]="params.cashflowCode" (update)="cashflowCategoryChanged($event)"></app-spend-category-search>
              </div>

              <div class="filter">
                <small>{{ 'spend-list.incomingNumber' | transloco }}</small>

                <input type="text" [(ngModel)]="params.incomingNumber" (ngModelChange)="applyFilters()"
                       class="form-control m-input" [placeholder]="'spend-list.incomingNumber' | transloco">
              </div>

              <div class="filter">
                <small>{{ 'spend-list.addExpense' | transloco }}</small>
                <hx-date-select [(ngModel)]="params.paidDate" (selectChange)="applyFilters()"></hx-date-select>
              </div>

              <div class="filter">
                <small class="d-block invisible d-none-xs">{{ 'spend-list.reset' | transloco }}</small>
                <button type="button" (click)="resetFilter()" class="btn btn-outline-primary">
                  <span>{{ 'reset.list' | transloco }}</span>
                </button>
              </div>
            </div>
          </div>

          <div
            class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-20 m--margin-bottom-30"
            *ngIf="list.length && !isLoading.list">
            <table class="m-datatable__table">
              <thead class="m-datatable__head">
              <tr class="m-datatable__row m-datatable__row--head">
                <th class="m-datatable__cell">
                  <span>#</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'spend-list.table.head.incomingDate' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'spend-list.table.head.num' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'spend-list.table.head.consumption' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'spend-list.table.head.cashflowName' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'spend-list.table.head.dataPaid' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'spend-list.table.head.organization' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'spend-list.shop' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'spend-list.table.head.spent' | transloco }}</span>
                </th>
                <th class="m-datatable__cell">
                  <span>{{ 'spend-list.table.head.payBefore' | transloco }}</span>
                </th>
                <th class="m-datatable__cell text-right">
                  <span></span>
                </th>
              </tr>
              </thead>
              <tbody class="m-datatable__body">
              <tr *ngFor="let even = even; let i = index; let item of list"
                  class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even }">
                <td class="m-datatable__cell">
                  <a [routerLink]="['show', item.id]">
                    {{ item.id }}
                  </a>
                </td>
                <td class="m-datatable__cell">
                  {{ item.date | date:'dd.MM.yyyy' }}
                </td>
                <td class="m-datatable__cell">
                  {{ item.incomingNumber }}
                </td>
                <td class="m-datatable__cell">
                  <span>{{ item.spendCategory?.title | uiLabel }}</span>
                  <span *ngIf="item.products.length > 0">{{ item.products | joined: 'title.' + lang }}</span>
                </td>
                <td class="m-datatable__cell">
                  {{ item.cashflowCategory.title | uiLabel }}
                </td>
                <td class="m-datatable__cell text-nowrap">
                  {{ item.paid | date:'dd.MM.yyyy' }}
                </td>
                <td class="m-datatable__cell">
                  {{ item.organization.title | uiLabel }}
                </td>
                <td class="m-datatable__cell">
                  {{ item.store.title | uiLabel }}
                </td>
                <td class="m-datatable__cell">
                  {{ item.total | uiCurrency:item.currency }}
                </td>
                <td class="m-datatable__cell">
                  {{ item.payBefore | date:'dd.MM.yyyy' }}
                </td>
                <td class="m-datatable__cell text-nowrap">
                  <button type="button" *ngIf="!item.paid && item.products.length === 0" [routerLink]="[item.id]"
                          class="btn btn-outline-primary btn-sm mr-2" [title]="'spend-list.change' | transloco">
                    <i class="la la-edit"></i>
                  </button>

                  <button *ngIf="!item.paid && item.products.length === 0"
                          type="button" (click)="showDeleteDialog(item)" class="btn btn-outline-danger m-btn btn-sm m-btn--icon" [ngbTooltip]="'del-button.delete' | transloco">
                    <i class="la la-trash"></i>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>

          <div class="m--align-center" *ngIf="list.length && !isLoading.list && pagination.allItemCount > 0">
            <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="pagination.allItemCount"
                            [(page)]="params.page" [pageSize]="params.limit" (pageChange)="pageChanged($event)"
                            class="d-flex justify-content-center mt-4">
            </ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #templateRef>
  <div class="modal-body">
    <p>{{ 'del-button.ts.delete' | transloco }}</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-link" (click)="dialogRef?.dismiss()">{{ 'del-button.btn.no' | transloco }}</button>

    <button type="button" class="btn btn-danger" (click)="dialogRef?.close()">{{ 'del-button.btn.yes' | transloco }}</button>
  </div>
</ng-template>

